import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'sg-wisdomcard-dialog',
  templateUrl: './wisdomcard-dialog.component.html',
  styleUrls: ['./wisdomcard-dialog.component.scss']
})
export class WisdomcardDialogComponent {

  @Input() playerName: string;
  @Output() wisdomcardDialogChange = new EventEmitter();

}
